import { useContext, useState, useCallback } from "react"
import { authorizerService } from "services/middleware_services"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import { SIMO_VAR, SIMO_VAR_POSTRENDER, SIMO_VAR_PRERENDER } from "constants/APP_CONSTANTS"
import { logInAction, logOutAction } from "store/actions/publicActions"
import { useNavigate } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import useAuth0Credentials from "hooks/useAuth0Credentials"
import { sharedStorage } from "utils/sharedStorage"

interface IErrorLogin {
  code: number
  message: string
}

const useAuthorizer = () => {
  const { logout: logout_auth0 } = useAuth0()
  const [error_login, set_error_login] = useState<IErrorLogin>({
    code: 0,
    message: "",
  })
  const { isCancel } = useCancelToken()
  const { dispatch } = useContext(AuthContext)
  const { set_loading_app } = useContext(AppContext)
  const navigate = useNavigate()
  const { clientId, audience } = useAuth0Credentials()

  const login_user_action = useCallback(async () => {
    try {
      set_loading_app(true)
      set_error_login({
        code: 0,
        message: "",
      })

      const credentials = {
        audience: audience,
        grant_type: "client_credentials",
        client_id: clientId,
      }

      const responseLogin = await authorizerService(credentials)
      const {
        data: { access_token },
      } = responseLogin
      dispatch(logInAction({ id: "guest", name: "Invitado", role: "guest", email: "guest", token: access_token }))
      set_loading_app(false)
      navigate("/dashboard")
    } catch (error: any) {
      set_loading_app(false)
      set_error_login({
        code: error?.response?.status,
        message: error.response?.data?.message,
      })
      if (isCancel(error)) return
    }
  }, [audience, clientId, dispatch, navigate, set_loading_app, isCancel])

  const logout_user_action = useCallback(() => {
    // Clear simo-v4 specific storage
    localStorage.removeItem(SIMO_VAR)
    localStorage.removeItem(SIMO_VAR_PRERENDER)
    localStorage.removeItem(SIMO_VAR_POSTRENDER)

    // Clear shared cross-domain storage (compatible with xmonitor modules)
    sharedStorage.clearAll()

    dispatch(logOutAction)

    // Logout from Auth0 and redirect to origin (clears Auth0 session cookie for SSO)
    logout_auth0({ logoutParams: { returnTo: window.location.origin, client_id: clientId, federated: true } } as any)
  }, [clientId, dispatch, logout_auth0])

  return {
    error_login,
    login_user_action,
    logout_user_action,
  }
}

export default useAuthorizer
